import React, { useState, useEffect } from "react";
import { BsMoon, BsSun } from "react-icons/bs";

function ThemeSwitcher() {
  // 1. Fonction pour déterminer le thème initial
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme;

    // 1. Vérifie si le système préfère le mode sombre (Media Query)
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (prefersDark) return "dark";

    // 2. Fallback sur l'heure si aucune préférence système n'est détectée
    const hour = new Date().getHours();
    return (hour >= 19 || hour < 7) ? "dark" : "light";
  };

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.classList.remove("day-mode", "dark-mode");
    document.documentElement.classList.add(theme === "light" ? "day-mode" : "dark-mode");
    localStorage.setItem("theme", theme);

    window.dispatchEvent(new Event("themeChanged"));
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <div className="theme-toggle-container" role="group" aria-label="Theme toggle">
      <BsMoon className="moon-icon" aria-hidden="true" onClick={() => setTheme("dark")} />
      <button
        className="toggle-button"
        onClick={toggleTheme}
        aria-pressed={theme === "light"}
        aria-label={theme === "light" ? "Switch to dark mode" : "Switch to day mode"}
      >
        <div className={`toggle-circle ${theme}`}></div>
      </button>
      <BsSun className="sun-icon" aria-hidden="true" onClick={() => setTheme("light")} />
    </div>
  );
}

export default ThemeSwitcher;